import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';

const REGION_KEYS = ['netherlands', 'brazil', 'ecuador', 'other'];

const TradeLaneMap = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-navy-900" data-testid="trade-lane-section">
      <div className="container-custom">
        <div className="max-w-3xl mb-14">
          <span className="text-gold text-sm font-semibold tracking-wider uppercase mb-4 block">
            {t('homePage.tradeLane.eyebrow')}
          </span>
          <h2 className="font-space text-3xl md:text-4xl font-bold text-white mb-4">
            {t('homePage.tradeLane.title')}
          </h2>
          <p className="text-lg text-platinum-light mb-4">{t('homePage.tradeLane.intro')}</p>
          <p className="text-platinum-light">{t('homePage.tradeLane.supportingText')}</p>
        </div>

        {/* Trade-lane visual with an equivalent text description */}
        <div className="rounded-2xl border border-royal/20 bg-navy-800/50 p-6 md:p-10 mb-12">
          <p className="sr-only">{t('homePage.tradeLane.textEquivalent')}</p>
          <div className="grid md:grid-cols-2 gap-4" aria-hidden="true">
            <div className="rounded-xl bg-navy-900 border border-gold/30 p-6 flex items-center gap-3">
              <ArrowRight className="w-5 h-5 text-gold" />
              <span className="text-white font-space font-semibold">
                {t('homePage.tradeLane.directions.europeToSouthAmerica')}
              </span>
            </div>
            <div className="rounded-xl bg-navy-900 border border-gold/30 p-6 flex items-center gap-3">
              <ArrowRight className="w-5 h-5 text-gold rotate-180" />
              <span className="text-white font-space font-semibold">
                {t('homePage.tradeLane.directions.southAmericaToEurope')}
              </span>
            </div>
          </div>
        </div>

        <dl className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {REGION_KEYS.map((key) => (
            <div key={key} className="rounded-xl bg-navy-800/50 border border-royal/20 p-6">
              <dt className="flex items-center gap-2 font-space font-bold text-white mb-2">
                <MapPin className="w-4 h-4 text-gold" aria-hidden="true" />
                {t(`homePage.tradeLane.regions.${key}.label`)}
              </dt>
              <dd className="text-sm text-platinum-light leading-relaxed">
                {t(`homePage.tradeLane.regions.${key}.description`)}
              </dd>
            </div>
          ))}
        </dl>

        <div className="mt-12">
          <Link to="/contact">
            <Button className="bg-gradient-to-r from-gold-light via-gold to-gold-dark text-navy-900 px-8 py-4 font-semibold">
              {t('homePage.tradeLane.cta')}
              <ArrowRight className="ml-2 w-5 h-5" aria-hidden="true" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TradeLaneMap;
